// src/ExamQuestions7.jsx
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import styles from '../css/modules/ExamQuestions.module.css';

const ExamQuestions7 = () => {
  const navigate = useNavigate();

  const handleNext = () => {
    navigate('/testy-strzeleckie-na-pozwolenie-na-bron');
  };

  return (
    <div className={styles.contactContainer}>
      <Helmet>
        <title>Egzamin na broń z nami to pestka! Patent strzelecki – szczegółowe dane broni i amunicji ISSF</title>
        <meta
          name="description"
          content="Zestaw pytań egzaminacyjnych dotyczących parametrów technicznych broni i amunicji w konkurencjach ISSF. Poznaj zasady dotyczące kalibrów, długości luf, oporu spustu i ograniczeń w ubiorze."
        />
      </Helmet>

      <div className={styles.content}>
        <h1 className="mainHeader">Twoja droga do patentu strzeleckiego – pytania na broń w jednym miejscu</h1>

        <div className="intro">
        <p>
          Planujesz podejść do <strong>egzaminu na broń</strong> i zdobyć upragniony <strong>patent strzelecki</strong>? 🚀 Świetnie! Pamiętaj, że opanowanie wiedzy o parametrach technicznych broni sportowej oraz właściwościach amunicji to jeden z filarów solidnego przygotowania. W tej części skupiamy się na zagadnieniach związanych z przepisami ISSF, które obowiązują podczas większości zawodów strzeleckich organizowanych zarówno w Polsce, jak i na arenie międzynarodowej.
        </p>

        <p>
          📘 Przed Tobą siódma odsłona naszego kompleksowego cyklu edukacyjnego! Na podstawie oficjalnych materiałów Polskiego Związku Strzelectwa Sportowego stworzyliśmy praktyczne i przystępne opracowanie, które pomoże Ci nie tylko nauczyć się teorii, ale przede wszystkim zrozumieć istotę zasad obowiązujących podczas egzaminu i zawodów.
        </p>

        <p>
          🔗 Zanim zanurzysz się w świat pytań, koniecznie zapoznaj się z naszymi przewodnikami:
          <ul>
            <li><a href="/praktyka-i-teoria-patentu-strzeleckiego">Jak wygląda egzamin na broń – krok po kroku</a></li>
            <li><a href="/pozwolenie-na-bron-i-ustawa-o-broni-i-amunicji">Pozwolenie na broń – zasady, procedury, formalności</a></li>
          </ul>
        </p>

        <p>
          🎮 Po zakończeniu nauki nie zapomnij sprawdzić swoich umiejętności na <a href="https://pistolet.org" target="_blank" rel="noopener noreferrer">pistolet.org</a>! Znajdziesz tam interaktywne quizy i testy, które sprawią, że <strong>egzamin na patent strzelecki</strong> stanie się dla Ciebie prostszy niż kiedykolwiek. 🚀
        </p>
      </div>


      <h2>🚫 Zakazana amunicja i definicje kalibrów</h2>
<ul className="reasonList">

  <li className={styles.customAnswer}>
    <h3>94. ❌ Jakiej amunicji nie można używać w zawodach ISSF?</h3>
    <p>
      W zawodach organizowanych pod patronatem ISSF obowiązują bardzo restrykcyjne zasady dotyczące rodzaju używanej amunicji. Niedozwolona jest amunicja:
      <ul>
        <li>🔹 wyposażona w pociski podkalibrowe lub zawierające elementy z tworzyw sztucznych,</li>
        <li>🔹 zawierająca materiały łatwopalne, zapalające lub wybuchowe, które mogłyby zagrażać bezpieczeństwu uczestników,</li>
        <li>🔹 wykonana z wyjątkowo twardych metali, takich jak wolfram czy jego stopy, ze względu na ich niszczycielską moc,</li>
        <li>🔹 amunicja wytwarzana poza profesjonalnymi fabrykami, z wyjątkiem amunicji elaborowanej do własnego użytku przez osoby posiadające odpowiednie pozwolenia na broń i umiejętności techniczne.</li>
      </ul>
      Wszystko po to, by zapewnić wyrównane szanse zawodnikom i pełne bezpieczeństwo podczas rywalizacji.
    </p>
  </li>

  <li className={styles.customAnswer}>
    <h3>95. 🎯 Czym jest kaliber broni?</h3>
    <p>
      Kaliber broni to podstawowy parametr techniczny określający średnicę wewnętrzną przewodu lufy lub średnicę pocisku, który jest do niej dostosowany. Podaje się go najczęściej w milimetrach (np. 5,6 mm) lub w calach (np. .22"). Znajomość kalibru jest niezbędna do prawidłowego doboru amunicji i wpływa bezpośrednio na celność, energię pocisku oraz zastosowanie danego typu broni w praktyce strzeleckiej.
    </p>
  </li>

  <li className={styles.customAnswer}>
    <h3>96. ⚖️ Co oznacza kaliber wagomiarowy?</h3>
    <p>
      Kaliber wagomiarowy to tradycyjny sposób określania średnicy lufy broni gładkolufowej. Oznacza on liczbę ołowianych kul, które można odlać z jednego funta ołowiu, przy założeniu, że każda kula ma średnicę odpowiadającą średnicy lufy. Przykład: dla kalibru 12, z jednego funta odlewa się 12 kul o średnicy przewodu lufy broni myśliwskiej. Im wyższa liczba kalibru wagomiarowego, tym mniejsza średnica lufy.
    </p>
  </li>

</ul>


<h2>📏 Parametry broni w konkurencjach ISSF</h2>
<ul className="reasonList">

  <li className={styles.customAnswer}>
    <h3>97. 📏 Jaka jest maksymalna długość lufy pistoletu dowolnego?</h3>
    <p>
      W konkurencji pistoletu dowolnego przepisy ISSF nie nakładają ograniczeń co do maksymalnej długości lufy. Zawodnik ma pełną swobodę w doborze konstrukcji, o ile broń spełnia wszystkie inne wymagania regulaminowe, takie jak dopuszczalny kaliber czy bezpieczeństwo użytkowania. Pozwala to na wykorzystywanie specjalistycznych modeli optymalizowanych pod kątem stabilności i celności.
    </p>
  </li>

  <li className={styles.customAnswer}>
    <h3>98. 📏 Jaka jest maksymalna długość lufy pistoletu sportowego?</h3>
    <p>
      W przypadku pistoletu sportowego obowiązuje ścisły limit długości lufy – maksymalnie 153 mm. Przekroczenie tej wartości skutkuje niedopuszczeniem zawodnika do startu. Ograniczenie to ma na celu zapewnienie równych warunków rywalizacji, zapobiegając nadmiernym przewagom wynikającym z długości przyrządów celowniczych lub stabilności konstrukcji.
    </p>
  </li>

  <li className={styles.customAnswer}>
    <h3>99. ⚖️ Jaka jest maksymalna masa karabinu pneumatycznego?</h3>
    <p>
      Karabin pneumatyczny używany w konkurencjach ISSF, wraz ze wszystkimi zamontowanymi akcesoriami (takimi jak celowniki optyczne, ciężarki balansujące, paski czy szyny montażowe), nie może ważyć więcej niż 5,5 kg. Limit ten wymusza kompromis pomiędzy stabilnością broni a jej poręcznością i komfortem użytkowania w czasie długich serii strzeleckich.
    </p>
  </li>

  <li className={styles.customAnswer}>
    <h3>100. ⚖️ Czy istnieje ograniczenie masy pistoletu dowolnego?</h3>
    <p>
      W konkurencji pistoletu dowolnego przepisy ISSF nie wprowadzają limitu masy broni. Oznacza to, że zawodnik może wybrać konstrukcję dowolnie ciężką lub lekką, dostosowując broń do swoich preferencji technicznych i stylu strzelania. Należy jednak pamiętać, że nadmierna masa może wpłynąć na zmęczenie mięśni i precyzję podczas długich serii.
    </p>
  </li>

  <li className={styles.customAnswer}>
    <h3>101. ⚖️ Jaka jest maksymalna masa pistoletu sportowego?</h3>
    <p>
      Pistolet sportowy w zawodach ISSF nie może ważyć więcej niż 1400 g, licząc razem z uchwytem, spustem i innymi zamontowanymi elementami. Przekroczenie tej granicy oznacza, że broń nie spełnia kryteriów regulaminowych i zawodnik nie zostanie dopuszczony do konkurencji. Limit masy wymusza na zawodnikach wybór lekkich, wyważonych konstrukcji sprzyjających szybkiemu i precyzyjnemu strzelaniu.
    </p>
  </li>

</ul>


        <h2>🎯 Opór spustu i wymiary broni</h2>
        <ul className="reasonList">
          <li className={styles.customAnswer}>
            <h3>102. 💡 Minimalny opór języka spustowego w pistolecie dowolnym?</h3>
            <p>Brak minimalnego oporu – zawodnik może ustawić go według własnych preferencji.</p>
          </li>

          <li className={styles.customAnswer}>
            <h3>103. 💡 Minimalny opór języka spustowego w pistolecie pneumatycznym?</h3>
            <p>500 g – wartość ta jest wymagana przepisami ISSF dla bezpieczeństwa.</p>
          </li>

          <li className={styles.customAnswer}>
            <h3>104. 💡 Minimalny opór języka spustowego w pistolecie sportowym?</h3>
            <p>1000 g – ustalony minimalny opór zapobiega przypadkowym strzałom i standardyzuje wyposażenie zawodników.</p>
          </li>

          <li className={styles.customAnswer}>
            <h3>105. 📦 Jakie wymiary musi spełniać pistolet sportowy?</h3>
            <p>Musi zmieścić się w pudełku 300 × 150 × 50 mm – sprawdzane podczas kontroli sprzętu przed zawodami.</p>
          </li>

          <li className={styles.customAnswer}>
            <h3>106. 📦 Jakie wymiary musi spełniać pistolet pneumatyczny?</h3>
            <p>Wymiary nie mogą przekraczać 420 × 200 × 50 mm – to jedno z podstawowych kryteriów dopuszczenia do konkurencji.</p>
          </li>
        </ul>

        <h2>🔄 Inne zasady ISSF</h2>
        <ul className="reasonList">
          <li className={styles.customAnswer}>
            <h3>107. 🔁 Czy można używać rewolweru w konkurencji „Pistolet sportowy 25 m”?</h3>
            <p>Tak – pod warunkiem że spełnia wymagania ISSF: kaliber, masa, długość i opór spustu.</p>
          </li>

          <li className={styles.customAnswer}>
            <h3>108. 💥 Ile naboi ładuje się do pistoletu dowolnego?</h3>
            <p>Jeden – to konkurencja precyzyjna, w której każdy strzał jest oddawany osobno.</p>
          </li>

          <li className={styles.customAnswer}>
            <h3>109. 👕 Jakie są zasady dotyczące ubioru zawodników?</h3>
            <p>Odzież nie może wspomagać zawodnika ani stabilizować pozycji. Zakazane są buty zakrywające kostki, kamizelki usztywniające, pasy stabilizujące itp.</p>
          </li>

          <li className={styles.customAnswer}>
            <h3>110. 🧍 Czym jest konkurencja „karabin dowolny 60 strzałów leżąc”?</h3>
            <p>To jedna z klasycznych konkurencji ISSF: 60 strzałów z karabinu palnego na odległość 50 metrów w pozycji leżącej. Każdy strzał jest punktowany indywidualnie.</p>
          </li>
        </ul>

        <div className="buttonContainer">
          <button onClick={handleNext} className={styles.secondaryButton}>
            Do kolejnych pytań
          </button>
          <button onClick={() => navigate('/')} className={styles.primaryButton}>
            Sprawdź testy na broń
          </button>
        </div>
      </div>
    </div>
  );
};

export default ExamQuestions7;
